import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { cache } from '@customerio/hydra-nav-state';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { analyzeBashCommand, getMutatingResources } from '../approval/parse-curl-resources';

export async function invalidateCacheForCommand(command: string) {
  const analysis = await analyzeBashCommand(command);
  const mutating = getMutatingResources(analysis.resources);

  if (mutating.length === 0) {
    return;
  }

  const entries = mutating
    .filter((resource) => resource.fullyResolved && resource.resourceId != null)
    .map((resource) => ({ type: resource.resourceType, id: resource.resourceId! }));

  if (entries.length > 0) {
    cache.invalidate(entries);
  }
}

export function BashTool() {
  const targetedInvalidation = useFeatureFlag(AccountFeatureFlag.AgentTargetedCacheInvalidation);

  useCopilotTool({
    type: 'server',
    name: 'bash',
    handler({ args, response, wasApproved }) {
      if (response?.error != null) {
        return;
      }

      if (wasApproved !== true) {
        return;
      }

      if (targetedInvalidation) {
        void invalidateCacheForCommand(String(args.command));
      } else {
        cache.invalidate({ type: 'all' });
      }
    },
  });

  return null;
}
